import React from 'react';
import { useParams } from 'react-router-dom';
import IndividualServiceSharedLayout from './IndividualServiceSharedLayout';
import { useTranslation } from '../../hooks/useTranslation';
import { getIndividualB2CData } from './IndividualServiceConfig/B2CIndividualConfig';
import { getIndividualB2BData } from './IndividualServiceConfig/B2BIndividualConfig';

const IndividualService = () => {
  console.log('IndividualService Component Rendered');
  const { type, id } = useParams();
  const t = useTranslation();

  let serviceData;

  if (type === 'b2c-logistics-services') {
    serviceData = getIndividualB2CData(id, t);
  } else if (type === 'b2b-logistics-services') {
    serviceData = getIndividualB2BData(id, t);
  }

  if (!serviceData) {
    return <div>Service not found.</div>;
  }

  return <IndividualServiceSharedLayout pageData={serviceData} />;
};

export default IndividualService;
